import { Component, HostListener, OnDestroy, OnInit, inject } from '@angular/core';
import { StorageService } from './services/storage/storage.service';
import { filter } from 'rxjs/operators';
import { Router,NavigationEnd } from '@angular/router';
import { HttpProgressService } from 'src/app/services/http-progress/http-progress.service';
import { AlertController } from '@ionic/angular';
import { UserService } from './services/user/user.service';
declare let gtag: Function;
declare let fbq:Function;

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  private readonly idleLimitMs = 30 * 60 * 1000;
  private readonly idleWarningSeconds = 10;
  private readonly httpProgressService = inject(HttpProgressService);
  isHttpLoading$ = this.httpProgressService.isLoading$;
  idleCountdownSeconds = this.idleWarningSeconds;
  private idleTimeoutRef: any;
  private idleCountdownRef: any;
  private idleAlert: HTMLIonAlertElement | null = null;
  //router:any;
  constructor(private router: Router,
    private storageService: StorageService,
    private userService: UserService,
    private alertController: AlertController) {
    /* router.events.subscribe((y: NavigationEnd) => {
      if(y instanceof NavigationEnd){
        fbq('track', 'PageView');
      }
    }); */
  }

  async ngOnInit() {
    await this.storageService.init();
    this.setUpAnalytics();
    this.resetIdleTimer();
  }

  ngOnDestroy() {
    this.clearIdleTimers();
  }

  setUpAnalytics() {
    this.router.events.pipe(filter(event => event instanceof NavigationEnd))
        .subscribe((event: NavigationEnd) => {
            gtag('config', 'G-7ZDML9GTL5',
                {
                    page_path: event.urlAfterRedirects
                }
            );
        });
    }

  @HostListener('document:mousemove')
  @HostListener('document:mousedown')
  @HostListener('document:keydown')
  @HostListener('document:touchstart')
  @HostListener('document:scroll')
  handleUserActivity() {
    if (this.idleAlert) {
      return;
    }

    this.resetIdleTimer();
  }

  private async resetIdleTimer() {
    this.clearIdleCountdown();
    if (this.idleAlert) {
      return;
    }

    clearTimeout(this.idleTimeoutRef);

    if (!(await this.hasActiveSession())) {
      return;
    }

    this.idleTimeoutRef = setTimeout(() => {
      this.showIdleWarning();
    }, this.idleLimitMs);
  }

  private clearIdleTimers() {
    clearTimeout(this.idleTimeoutRef);
    this.clearIdleCountdown();
  }

  private clearIdleCountdown() {
    clearInterval(this.idleCountdownRef);
    this.idleCountdownRef = null;
  }

  private async hasActiveSession(): Promise<boolean> {
    const token = await this.storageService.get('token');
    return !!token && this.router.url !== '/login';
  }

  private async showIdleWarning() {
    if (this.idleAlert || !(await this.hasActiveSession())) {
      return;
    }

    this.idleCountdownSeconds = this.idleWarningSeconds;
    this.idleAlert = await this.alertController.create({
      header: 'Session Idle',
      message: this.getIdleWarningMessage(),
      backdropDismiss: false,
      buttons: [
        {
          text: 'Continue',
          handler: () => {
            this.dismissIdleAlert(false);
            this.resetIdleTimer();
          },
        },
      ],
    });

    await this.idleAlert.present();
    this.startIdleCountdown();
  }

  private startIdleCountdown() {
    this.clearIdleCountdown();
    this.idleCountdownRef = setInterval(() => {
      this.idleCountdownSeconds -= 1;
      if (this.idleAlert) {
        this.idleAlert.message = this.getIdleWarningMessage();
      }

      if (this.idleCountdownSeconds <= 0) {
        this.forceLogoutForIdle();
      }
    }, 1000);
  }

  private getIdleWarningMessage(): string {
    return `Your session has been idle for the past 30 minutes. Would you like to continue? Otherwise, you will be automatically logged out in ${this.idleCountdownSeconds} seconds.`;
  }

  private async dismissIdleAlert(force: boolean) {
    this.clearIdleCountdown();
    if (this.idleAlert) {
      const alert = this.idleAlert;
      this.idleAlert = null;
      await alert.dismiss(undefined, force ? 'timeout' : 'continue');
    }
  }

  private async forceLogoutForIdle() {
    await this.dismissIdleAlert(true);

    await this.userService.logoutService().then((res: any) => {
    }).catch((err: any) => { }).finally(() => {
      localStorage.clear();
      this.storageService.clear().then((res) => {
      });
      this.router.navigate(['/login']);
    }); 
  }
}
